import styled from 'styled-components';
import Box from './Box';
import { useQuestionContext } from '../../../context/chatbot/QuestionContextApi';

const Button = styled.button`
  outline: none !important;
  border: none !important;
  background: none !important;
  transition: all 0.5s ease-in-out !important;
  &:hover {
    cursor: pointer !important;
    transform: scale(1.05) !important;
  }
  &:disabled {
    cursor: not-allowed !important;
  }
`;

interface IProps {
  children: string;
  id: number;
}

const QuestionButton: React.FC<IProps> = ({ children, id }) => {
  const questionContext = useQuestionContext();
  if (!questionContext) {
    throw new Error('There is no question context');
  }
  const {
    setQuestion,
    question: { isLoading },
  } = questionContext;
  const clickHandler = (val: string) => {
    setQuestion({
      content: val,
      streamAnswer: '',
      isLoading: true,
    });
  };

  return (
    <div className="md:col-start-1 md:col-span-4 col-start-1 col-span-4 sm:text-base text-xs flex justify-center m-1">
      <Button
        disabled={isLoading}
        onClick={() => clickHandler(children)}
        // data-aos="fade-left"
        // data-aos-delay={`${id * 500}`}
      >
        <Box id={id} type="defaultQuestion">
          {children}
        </Box>
      </Button>
    </div>
  );
};

export default QuestionButton;
